import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import useFetch from '../hooks/useFetch';
import { AuthContext } from '../App';
import './StudyDetails.css';

const StudyDetails = () => {
    const { id } = useParams();
    const { apiBaseUrl, token } = useContext(AuthContext);

    const qidoUrl = `${apiBaseUrl}/qido/studies?StudyInstanceUID=${id}`;
    const { data: seriesList, isLoading, error } = useFetch(qidoUrl, token);

    if (isLoading) return <div className="study-details">Loading...</div>;
    if (error) return <div className="study-details">{error}</div>;

    const studyInfo = (seriesList && seriesList.length) ? seriesList[0] : null;

    return (
        <div className="study-details">
            {!studyInfo && <div>No study found for ID: {id}</div>}

            {studyInfo && (
                <article>
                    <h2>Study Details</h2>
                    <div><strong>PatientID:</strong> {studyInfo.PatientID || ''}</div>
                    <div><strong>PatientName:</strong> {studyInfo.PatientName || ''}</div>
                    <div><strong>StudyDate:</strong> {studyInfo.StudyDate || ''}</div>
                    <div><strong>StudyDescription:</strong> {studyInfo.StudyDescription || ''}</div>

                    <h3>Series</h3>
                        {seriesList.map((s, idx) => (
                            <div key={s.SeriesInstanceUID || idx} className="series-preview">
                            <div><strong>SeriesDescription:</strong> {s.SeriesDescription || ''}</div>
                            <div><strong>SeriesInstanceUID:</strong> {s.SeriesInstanceUID || ''}</div>
                            <div><strong>SeriesNumber:</strong> {s.SeriesNumber || ''}</div>
                            <div><strong>SeriesDate:</strong> {s.SeriesDate || ''}</div>
                            <div><strong>StudyInstanceUID:</strong> {s.StudyInstanceUID || ''}</div>
                            <div><strong>Modality:</strong> {s.Modality || ''}</div>
                            <div><strong>InstanceCount:</strong> {s.InstanceCount || 0}</div>
                        </div>
                    ))}
                </article>
            )}
        </div>
    );
}

export default StudyDetails;
